import get from 'lodash-es/get';

/**
 * Model to hold a ranking group
 */
export class IdentityRankingGroup {
    public id: string = null;
    public parentId: string = null;
    public seasonId: string = null;
    public isExcluded: boolean = null;
    public name: string = null;
    public nameAliases: string[] = [];
    public children: IdentityRankingGroup[] = [];

    constructor(id?: string, parentId?: string) {
        this.id = id;
        this.parentId = parentId;
    }

    public clone(): IdentityRankingGroup {
        const clone: IdentityRankingGroup = new IdentityRankingGroup();
        clone.id = this.id;
        clone.seasonId = this.seasonId;
        clone.parentId = this.parentId;
        clone.name = this.name;
        clone.nameAliases = this.nameAliases && this.nameAliases.map((a: string) => a);
        clone.isExcluded = this.isExcluded;
        clone.children = this.children && this.children.map((e: IdentityRankingGroup) => e.clone());

        return clone;
    }

    public serialize(): string {
        const json: any = {
            data: {
                type: 'rankingGroup',
                id: this.id,
                attributes: {
                    name: this.name,
                    nameAliases: this.nameAliases,
                    isExcluded: this.isExcluded || false,
                },
                relationships: {
                    season: { data: { type: 'season', id: this.seasonId } },
                    parent: { data: { type: 'parent', id: this.parentId || null } },
                },
            },
        };

        return JSON.stringify(json);
    }

    public deserialize(json: any, included: any[] = []): IdentityRankingGroup {
        json = json.data || json;
        const attrs: any = json.attributes || {};
        included = included || [];

        this.id = json.id;
        this.name = attrs.name;
        this.nameAliases = attrs.nameAliases || [];
        this.seasonId = attrs.seasonId;
        this.parentId = attrs.parentId;
        this.isExcluded = attrs.isExcluded;

        const children: any[] = get(json, 'relationships.children.data') || [];
        children.forEach((x: any) => {
            const item: any = included.find((i: any) => i.id === x.id);

            if (item) {
                this.children.push((new IdentityRankingGroup()).deserialize(item));
            }
        });

        return this;
    }
}
